module.exports = __webpack_public_path__ + "img/spain.69bf7c3d.png";